<template>
  <div class="accordion-item">
    <button
      class="accordion"
      :class="{ active: isActuallyOpen }"
      @click="toggle"
    >
      {{ title }}
    </button>
    <div
      class="panel-accordion"
      ref="panel"
      :style="{ maxHeight: isActuallyOpen ? panelHeight + 'px' : '0px' }"
    >
      <div class="panel-content" ref="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    title: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: null // null означає: не керується зовні
    }
  },
  emits: ["toggle"],
  data() {
    return {
      internalOpen: false,
      panelHeight: 0
    };
  },
  computed: {
    isControlled() {
      return this.isOpen !== null;
    },
    isActuallyOpen() {
      return this.isControlled ? this.isOpen : this.internalOpen;
    }
  },
  watch: {
    isActuallyOpen() {
      this.setHeight();
    }
  },
  mounted() {
    this.setHeight();
  },
  methods: {
    toggle() {
      if (this.isControlled) {
        this.$emit("toggle");
      } else {
        this.internalOpen = !this.internalOpen;
      }
    },
    setHeight() {
      this.$nextTick(() => {
        const content = this.$refs.content;
        this.panelHeight = this.isActuallyOpen ? content.scrollHeight : 0;
      });
    }
  }
};
</script>

<style scoped>
.accordion-item {
  border: 1px solid #eee;
  margin-bottom: 15px;
}

.accordion {
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 20px;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  text-align: left;
  transition: background-color 0.4s;
  position: relative;
}

.accordion:hover,
.accordion.active {
  background-color: #ccc;
}

.accordion::after {
  content: '\002B';
  color: #777;
  font-weight: bold;
  float: right;
  margin-left: 5px;
}

.accordion.active::after {
  content: '\2212';
}

.panel-accordion {
  background-color: white;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}

.panel-content {
  padding: 15px 15px;
}
</style>
